import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UserAccountType } from '../../models/user';

export function siteTypeGuard(
  expectedSiteType: UserAccountType,
): CanActivateFn {
  return () => {
    const router = inject(Router);
    const isSMESite = environment.isSMESite;
    const currentSiteType = isSMESite
      ? UserAccountType.SME
      : UserAccountType.CDFI;

    if (currentSiteType !== expectedSiteType) {
      router.navigate(['/error'], { queryParams: { code: 403 } });
      return false;
    }

    return true;
  };
}
